var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { H2 } from "@irati/ui/src/Headings";
import { pngToJpg, jpgToPng } from "@irati/images/helpers/convert";
import { StyledPreview, StyledH4 } from "./styled";
import UploadedImage from "./UploadedImage";
var UploadSuccess = /** @class */ (function (_super) {
    __extends(UploadSuccess, _super);
    function UploadSuccess() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UploadSuccess.prototype.render = function () {
        var _a = this.props, uploadedImage = _a.uploadedImage, clear = _a.clear;
        return (React.createElement(React.Fragment, null,
            React.createElement(H2, null, "Image Uploaded Successfully"),
            React.createElement(StyledPreview, null,
                React.createElement("img", { src: uploadedImage, alt: "Preview of uploaded file" })),
            React.createElement(StyledH4, null, "JPG"),
            React.createElement(UploadedImage, { uploadedImage: pngToJpg(uploadedImage), clear: clear }),
            React.createElement(StyledH4, null, "PNG"),
            React.createElement(UploadedImage, { uploadedImage: jpgToPng(uploadedImage), clear: clear })));
    };
    return UploadSuccess;
}(PureComponent));
export default UploadSuccess;
